<template>
  <router-link tag="a" :to="href">
    <div class="item" @mouseenter="hovered = true" @mouseleave="hovered = false">
      <i :class="icon"></i>
      <div v-if="hovered" class="name">{{ name }}</div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hovered: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.item {
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.7rem;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 0.625rem;
  border: 1px solid #eaebf1;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(101, 101, 101, 0.05);
  transition: all 500ms;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    width: auto;
    border-color: #ff7c48;
    background-color: #ff7c48;

    .name {
      color: #fff;
    }

    i {
      color: #fff;
    }
  }
}

.name {
  color: #e15f2b;
  font-family: "Roboto";
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

i {
  font-size: 34px;
  color: #b6b7bf;
}
</style>
